export interface FAQItem {
  question: string;
  answer: string;
}

export const faqItems: FAQItem[] = [
  {
    question: "51cg平台是正规平台吗？",
    answer: "根据目前的调查信息，51cg平台的运营主体信息不透明，存在多层股权嵌套。多个监管部门已对其展开调查。建议用户在充分了解风险之前，谨慎对待该平台。",
  },
  {
    question: "51cg平台上的收益是真的吗？",
    answer: "据前员工爆料和用户反馈，51cg平台存在数据造假的情况。部分用户展示的高收益截图真实性存疑。平台承诺的高额收益缺乏实体经济支撑，存在庞氏骗局特征。",
  },
  {
    question: "在51cg平台投资安全吗？",
    answer: "从目前掌握的信息来看，51cg平台存在多项安全隐患，包括数据安全漏洞、资金管理不规范、客服体系不健全等。多个安全研究机构和法律专家均对其风险水平提出了警告。",
  },
  {
    question: "如果已经在51cg平台上投入了资金，应该怎么办？",
    answer: "建议立即尝试提现测试平台的兑付能力；保存所有交易记录和平台公告作为证据；不要继续追加投入；如果遇到提现困难，可以通过12315、消费者协会等渠道进行维权；涉及金额较大的建议寻求法律帮助。",
  },
  {
    question: "51cg平台是否涉及传销？",
    answer: "51cg平台的运营模式中存在鼓励用户拉新推广并给予奖励的机制，这是传销的典型特征之一。法律专家指出，其部分业务模式可能触及非法集资和传销的法律红线。",
  },
  {
    question: "如何辨别类似51cg的风险平台？",
    answer: "可以通过以下几个维度来判断：1. 运营主体是否透明可查；2. 收益来源是否清晰合理；3. 是否采用第三方资金托管；4. 用户口碑是否真实多元；5. 是否有合法的经营资质。如果以上多项不满足，建议保持警惕。",
  },
  {
    question: "51cg平台会被关闭吗？",
    answer: "鉴于目前多个监管部门已介入调查，且平台存在多项违规问题，51cg平台面临较大的监管风险。建议用户密切关注官方通报，提前做好应对准备。",
  },
  {
    question: "你们的爆料信息可靠吗？",
    answer: "我们的所有爆料信息均来自公开渠道、用户投稿和独立调查，每条信息都经过多方交叉验证后再发布。但受限于信息获取渠道，我们无法保证100%的准确性，建议读者结合多方信息做出独立判断。",
  },
];